import { Zap } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div
      className="border-y lp-hairline bg-[#0c0c0f] py-4 overflow-hidden"
      data-testid="marquee-section"
      aria-hidden="true"
    >
      <div className="lp-marquee-track">
        {items.map((text, i) => (
          <span key={i} className="flex items-center gap-6 px-6 whitespace-nowrap">
            <span className="text-sm sm:text-base font-semibold uppercase tracking-[0.18em] text-[#a1a1aa]">
              {text}
            </span>
            <Zap size={14} className="text-[#f5a623]" fill="currentColor" />
          </span>
        ))}
      </div>
    </div>
  );
};
